import OperationFilter from "./OperationFilter"

export default class OperationsPageRequest {
    constructor(number, filter) {
        this.number = number
        this.filter = (filter !== null && filter !== undefined) ? filter : new OperationFilter()
    }
}